export default "__VITE_ASSET__B8FZDn81__"